var _path, _path2, _path3, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStandarIcon4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2239 0.0510564C11.3839 0.230393 10.5816 0.815614 10.1663 1.57072L9.88313 2.0804L9.85482 23.8556L9.83594 45.6309L10.0342 46.1594C10.2984 46.8579 10.9686 47.5375 11.6765 47.8018L12.2051 48C12.2051 48 29.9405 48 33.9992 48C38.0578 48 38.0578 48 38.0578 48L38.0579 33.0018L38.1522 20.1556L38.039 11.7551L38.0107 5.57275L37.7464 5.03474C37.4538 4.4401 36.9346 3.93985 36.3022 3.63781C35.9813 3.49622 33.1874 3.03372 24.7209 1.75005C18.5857 0.825053 13.3566 0.0416211 13.0923 0.0133048C12.8375 -0.0150115 12.441 0.0038626 12.2239 0.0510564ZM24.0885 3.77939C30.1387 4.69495 35.2073 5.4878 35.3584 5.54443C35.4999 5.60107 35.7076 5.7804 35.802 5.94086C35.9719 6.22403 35.9813 6.8281 35.9813 26.0737V45.9235H33.0081H30.0443L30.016 41.0342L29.9877 36.1543L29.7234 35.6258C29.4214 35.0028 28.789 34.3799 28.166 34.0967C27.7318 33.8985 27.6186 33.889 23.9375 33.889H20.1525L19.5012 34.2194C19.0387 34.4554 18.7556 34.6819 18.5007 35.0217C17.8589 35.8617 17.8589 35.8712 17.8589 41.1758V45.9235H15.2632C12.4316 45.9235 12.2428 45.8952 12.0257 45.4043C11.8653 45.0645 11.8653 2.96765 12.0163 2.66561C12.1768 2.3447 12.4977 2.1276 12.8091 2.1276C12.9602 2.1276 18.0288 2.87327 24.0885 3.77939ZM27.4581 36.1638C27.9301 36.5225 27.9489 36.6546 27.9489 41.4589L27.9584 45.9235H23.9469H19.9354V41.3457C19.9354 37.5796 19.9637 36.7112 20.0676 36.5036C20.1903 36.2676 20.4074 36.1072 20.7849 35.975C20.8604 35.9467 22.3329 35.9373 24.0602 35.9467C27.0711 35.9656 27.2033 35.975 27.4581 36.1638Z",
    fill: "url(#paint0_linear_396_1854)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5051 12.8893C21.0993 13.1064 20.986 13.3046 20.9766 13.8143C20.9766 14.2013 21.0238 14.3145 21.2503 14.5505L21.524 14.8242H23.997H26.4699L26.7436 14.5505C26.9702 14.3145 27.0174 14.1918 27.0174 13.8143C27.0174 13.3046 26.8192 13.0025 26.385 12.8326C26.2623 12.7854 25.1674 12.7477 23.9687 12.7477C22.1942 12.7477 21.7222 12.776 21.5051 12.8893Z",
    fill: "url(#paint1_linear_396_1854)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5051 18.9283C21.0993 19.1454 20.986 19.3436 20.9766 19.8533C20.9766 20.2403 21.0238 20.3536 21.2503 20.5896L21.524 20.8633H23.997H26.4699L26.7436 20.5896C26.9702 20.3536 27.0174 20.2309 27.0174 19.8533C27.0174 19.3436 26.8192 19.0416 26.385 18.8717C26.2623 18.8245 25.1674 18.7868 23.9687 18.7868C22.1942 18.7868 21.7222 18.8151 21.5051 18.9283Z",
    fill: "url(#paint2_linear_396_1854)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5051 24.9713C21.0993 25.1884 20.986 25.3866 20.9766 25.8963C20.9766 26.2833 21.0238 26.3966 21.2503 26.6325L21.524 26.9062H23.997H26.4699L26.7436 26.6325C26.9702 26.3966 27.0174 26.2739 27.0174 25.8963C27.0174 25.3866 26.8192 25.0846 26.385 24.9147C26.2623 24.8675 25.1674 24.8297 23.9687 24.8297C22.1942 24.8297 21.7222 24.858 21.5051 24.9713Z",
    fill: "url(#paint3_linear_396_1854)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_396_1854",
    x1: 9.96036,
    y1: 23.9698,
    x2: 38.1522,
    y2: 23.9698,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C8FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.343347,
    stopColor: "#5C8EF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.667816,
    stopColor: "#7E8DF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9B8DF2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_396_1854",
    x1: 21.0031,
    y1: 13.7846,
    x2: 27.0174,
    y2: 13.7846,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C8FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.343347,
    stopColor: "#5C8EF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.667816,
    stopColor: "#7E8DF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9B8DF2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_396_1854",
    x1: 21.0031,
    y1: 19.8237,
    x2: 27.0174,
    y2: 19.8237,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C8FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.343347,
    stopColor: "#5C8EF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.667816,
    stopColor: "#7E8DF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9B8DF2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_396_1854",
    x1: 21.0031,
    y1: 25.8667,
    x2: 27.0174,
    y2: 25.8667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C8FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.343347,
    stopColor: "#5C8EF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.667816,
    stopColor: "#7E8DF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9B8DF2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStandarIcon4);
export default __webpack_public_path__ + "static/media/standar-icon-4.7731658330971edd6813bd5a0e5fd5c5.svg";
export { ForwardRef as ReactComponent };